import React from 'react';
import classes from './TwitterCard.module.scss';
import { LinkTwitterCard, Maybe, TwitterCard } from '../../../../models/graphql';
import { ReactComponent as NoImage } from '../../../../assets/images/no-image-130.svg';
import classNames from 'classnames';
import { Icon } from '../../../../components/images/Icon/Icon';
import { IconsEnum } from '../../../../constants/icons';

// The utility type to make nullable types non-nullable.
type NonNullableProperties<T> = {
  [K in keyof T]: T[K] extends Maybe<infer U> ? U : T[K];
};
type NonNullableAndRequiredTwitterCard = Required<NonNullableProperties<TwitterCard>>;

export type TwitterCardViewProps = NonNullableAndRequiredTwitterCard & {
  link: string | null;
};

export const TwitterCardView = (props: TwitterCardViewProps): JSX.Element => {
  const { description, card, image, title, link } = props;
  switch (card) {
    case 'SUMMARY':
    case 'APP':
    case 'PLAYER':
    default:
      return (
        <div className={classNames(classes.TwitterCard, classes.TwitterCardSummary)}>
          <div className={'grid-x'}>
            <div className={classNames('cell', classes.ImageWrapperSummary)}>
              {image ? (
                <img
                  alt={title ?? 'no image'}
                  src={image}
                  className={classNames(classes.Image, classes.ImageSummary)}
                />
              ) : (
                <NoImage />
              )}
              {card === LinkTwitterCard.PLAYER ? (
                <div className={classes.PlayButton}>
                  <Icon name={IconsEnum.play} size={'large'} />
                </div>
              ) : null}
            </div>
            <div className={classNames('cell', 'auto')}>
              <div className={classNames(classes.TextWrapperSummary, 'grid-y', 'align-center')}>
                {link ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.LinkTitle, classes.LinkTitleSummary)}>
                      {link.replace(/(^\w+:|^)\/\/(www\.)?/, '')}
                    </div>
                  </div>
                ) : null}
                {title ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.Title, classes.TitleSummary)}>{title}</div>
                  </div>
                ) : null}
                {description ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.Description, classes.DescriptionSummary)}>{description}</div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
    case 'SUMMARY_LARGE_IMAGE':
      return (
        <div className={classNames(classes.TwitterCard, classes.TwitterCardSummaryLarge)}>
          <div className={'grid-y'}>
            <div className={classNames('cell')}>
              {image ? (
                <div className={classes.ImageWrapperSummaryLarge}>
                  <img
                    alt={title ?? 'no image'}
                    src={image}
                    className={classNames(classes.Image, classes.ImageSummaryLarge)}
                  />
                </div>
              ) : (
                <div className={classNames(classes.ImageWrapperSummaryLarge, classes.ImageWrapperSummaryLargeNoImage)}>
                  <NoImage />
                </div>
              )}
            </div>
            <div className={classNames('cell', 'auto')}>
              <div className={classNames(classes.TextWrapperSummaryLarge, 'grid-y', 'align-center')}>
                {link ? (
                  <div className={'grid-x'}>
                    <div className={classes.LinkTitle}>{link.replace(/(^\w+:|^)\/\/(www\.)?/, '')}</div>
                  </div>
                ) : null}
                {title ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.Title, classes.TitleSummaryLarge)}>{title}</div>
                  </div>
                ) : null}
                {description ? (
                  <div className={'grid-x'}>
                    <div className={classNames(classes.Description, classes.DescriptionSummaryLarge)}>
                      {description}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      );
  }
};
